import { useEffect, useRef, useState } from "react";
import { cx } from "../lib/cx";

/** Native tooltip only once the line actually overflows. */
export function titleWhenTruncated(
  scrollWidth: number,
  clientWidth: number,
  text: string,
): string | undefined {
  const value = text.trim();
  if (!value) return undefined;
  return scrollWidth > clientWidth + 1 ? value : undefined;
}

/** Single-line text that keeps the full string in `title` when it is cut off. */
export function Truncate({ text, className }: { text: string; className?: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const [title, setTitle] = useState<string | undefined>(undefined);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = () => setTitle(titleWhenTruncated(el.scrollWidth, el.clientWidth, text));
    check();
    const observer = new ResizeObserver(check);
    observer.observe(el);
    return () => observer.disconnect();
  }, [text]);

  return (
    <span ref={ref} className={cx("block min-w-0 truncate", className)} title={title}>
      {text}
    </span>
  );
}
